import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type modulesAdminPermissionType = 'modules_admin_view';

export const modulesAdminPermissionMatrix: IPermissionMatrix<modulesAdminPermissionType> = {
  modules_admin_view: [UserRole.admin]
};
